import React, { useEffect, useState } from 'react';
import LayoutWithNavbar from './LayoutWithNavbar';
import { FaEdit, FaPlus, FaTrash } from 'react-icons/fa';
import { fetchUsers, createUser, updateUser, deleteUser, fetchRoles } from '../services/api';

const UserMasterPage = () => {
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState({
    open: false,
    mode: 'add',
    user: { id: null, username: '', email: '', mobile_no: '', password: '', is_active: true, role: '' }
  });

  const loadUsers = async () => {
    setLoading(true);
    const res = await fetchUsers();
    if (res.success) setUsers(res.data);
    else alert(res.message);
    setLoading(false);
  };

  const loadRoles = async () => {
    const res = await fetchRoles();
    if (res.success) setRoles(res.data);
  };
  


  useEffect(() => {
    loadUsers();
    loadRoles()
  }, []);


  const openModal = (mode, user = { id: null, username: '', email: '', mobile_no: '', password: '', is_active: true }) => {
    setModal({ open: true, mode, user });
  };

  const closeModal = () => {
    setModal({
      open: false,
      mode: 'add',
      user: { id: null, username: '', email: '', mobile_no: '', password: '', is_active: true }
    });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setModal({
      ...modal,
      user: {
        ...modal.user,
        [name]: type === 'checkbox' ? checked : value
      }
    });
  };

  const handleSubmit = async () => {
    const { id, username, email, mobile_no, password, is_active, role } = modal.user;
    if (!username.trim()) return alert('Username is required');

    const payload = { username: username.trim(), email, mobile_no, is_active, role };
    if (modal.mode === 'add') payload.password = password;

    const res = modal.mode === 'edit'
      ? await updateUser(id, payload)
      : await createUser(payload);

    if (res.success) {
      alert(`User ${modal.mode === 'edit' ? 'updated' : 'added'} successfully`);
      closeModal();
      loadUsers();
    } else {
      alert(res.message);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this user?')) return;
    const res = await deleteUser(id);
    if (res.success) {
      alert('User deleted successfully');
      loadUsers();
    } else {
      alert(res.message);
    }
  };

  return (
    <LayoutWithNavbar>
      <div style={styles.container}>
        <h2 style={styles.heading}>User Master</h2>

        <div style={{ textAlign: 'right', marginBottom: '20px' }}>
          <button style={styles.addButton} onClick={() => openModal('add')}>
            <FaPlus style={{ marginRight: '6px' }} /> New User
          </button>
        </div>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Username</th>
                <th style={styles.th}>Role</th>
                <th style={styles.th}>Email</th>
                <th style={styles.th}>Mobile No</th>
                <th style={styles.th}>Status</th>
                <th style={styles.th}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td style={styles.td}>{user.username}</td>
                  <td style={styles.td}>{user.role_display || '-'}</td>
                  <td style={styles.td}>{user.email}</td>
                  <td style={styles.td}>{user.mobile_no}</td>
                  <td style={styles.td}>{user.is_active ? 'Active' : 'Inactive'}</td>
                  <td style={styles.td}>
                    <button style={styles.iconButton} onClick={() => openModal('edit', user)}>
                      <FaEdit />
                    </button>
                    <button style={styles.deleteButton} onClick={() => handleDelete(user.id)}>
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {modal.open && (
          <div style={styles.modalBackdrop}>
            <div style={styles.modalBox}>
              <h4>{modal.mode === 'edit' ? 'Edit' : 'Add'} User</h4>
              <input name="username" placeholder="Username" value={modal.user.username} onChange={handleChange} style={styles.input} />
              <select name="role" value={modal.user.role} onChange={handleChange} style={styles.input}>
                <option value="">Select Role</option>
                {roles.map((r) => (
                    <option key={r.id} value={r.id}>{r.rolename}</option>
                ))}
              </select>

              <input name="email" placeholder="Email" value={modal.user.email} onChange={handleChange} style={styles.input} />
              <input name="mobile_no" placeholder="Mobile No" value={modal.user.mobile_no} onChange={handleChange} style={styles.input} maxlength='10' type='number'/>
              {modal.mode === 'add' && (
                <input name="password" placeholder="Password" type="password" value={modal.user.password} onChange={handleChange} style={styles.input} />
              )}

              
              <div style={{ marginTop: '10px', textAlign: 'left' }}>
                <label>
                  <input type="checkbox" name="is_active" checked={modal.user.is_active} onChange={handleChange} />
                  &nbsp; Active
                </label>
              </div>
              <div style={{ marginTop: '20px' }}>
                <button style={styles.saveButton} onClick={handleSubmit}>Save</button>
                <button style={styles.cancelButton} onClick={closeModal}>Cancel</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </LayoutWithNavbar>
  );
};

const styles = {
  container: { padding: '30px' },
  heading: { fontSize: '24px', fontWeight: '600', marginBottom: '20px' },
  addButton: { padding: '10px 16px', fontSize: '16px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  table: { width: '100%', borderCollapse: 'collapse', textAlign: 'center' },
  th: { padding: '12px', background: '#333', color: '#fff', fontWeight: '600' },
  td: { padding: '10px', borderBottom: '1px solid #ddd' },
  iconButton: { marginRight: '8px', padding: '6px 10px', backgroundColor: '#ffc107', color: '#000', border: 'none', borderRadius: '4px', cursor: 'pointer' },
  deleteButton: { padding: '6px 10px', backgroundColor: '#dc3545', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' },
  modalBackdrop: { position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center' },
  modalBox: { background: '#fff', padding: '30px', borderRadius: '10px', width: '400px', textAlign: 'center' },
  input: { width: '100%', padding: '10px', margin: '10px 0', fontSize: '16px', borderRadius: '6px', border: '1px solid #ccc' },
  saveButton: { padding: '10px 20px', backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  cancelButton: { padding: '10px 20px', backgroundColor: '#6c757d', color: '#fff', border: 'none', borderRadius: '6px', marginLeft: '10px', cursor: 'pointer' }
};

export default UserMasterPage;
